import { HttpClient } from '#client/http/index'
import { CampaignCode, Campaign } from '#client/resources/index'
import { ApiResponse } from '#client/resources/types'

export const getByCode = async (
  { httpClient }: { httpClient: HttpClient },
  code: CampaignCode,
): Promise<Campaign | null> => {
  const { data }: ApiResponse<Campaign> = await httpClient.get(
    `/user/campaigns/${code}`,
  )
  return data
}
